import {useState} from 'react';
import {Link} from 'react-router-dom';
import NavMain from './NavMain';
function Header() {

    const [isNavOpen, setNavOpen] = useState(false);
    const [navShow, setNavShow] = useState(false);

    function handleClick(){
        setNavOpen(!isNavOpen); // set is nav open to the opposite of what it is
    }

    return (
        <header className="site-header">
            <h1 className="site-title"><Link to="/">&#60; Patrick / Neil &#62;</Link></h1>
            {/* toggle class for hamburger menu */}
                <button className="main-nav-button" onClick={handleClick}>
                    {/* Check if the nav is active if not set it to hamburger is it is set it to is active and hamburger */}
                    <div className={isNavOpen ? 'hamburger is-active' : 'hamburger'} id="hamburger-5">
                        <span className="line"></span>
                        <span className="line"></span>
                        <span className="line"></span>
                    </div>
                    <span className="screen-reader-text">Hamburger Menu</span>
                </button>
            <NavMain navShow={isNavOpen}/> {/* Main Site Navigation */}
        </header>
    )
}

export default Header
